import { Link } from "react-router-dom";

const areas = [
  { city: "Colorado Springs", services: "Custom Homes, Remodeling, Commercial" },
  { city: "Monument", services: "Custom Homes, Additions, Renovations" },
  { city: "Falcon", services: "Residential Construction, Remodeling" },
  { city: "Pueblo", services: "Commercial Construction, Renovations" },
  { city: "Castle Rock", services: "Custom Homes, Additions" },
  { city: "Fountain", services: "Residential Builds, Remodeling" },
  { city: "Security-Widefield", services: "Home Additions, Renovations" },
  { city: "Peyton", services: "Custom Home Building" },
  { city: "Manitou Springs", services: "Renovations, Exterior Upgrades" },
  { city: "Black Forest", services: "Custom Homes, Additions" },
  { city: "Woodland Park", services: "Residential Construction" },
  { city: "Canon City", services: "Commercial & Residential Builds" },
];

interface ServiceAreasProps {
  title?: string;
  subtitle?: string;
  focusCity?: string;
}

export default function ServiceAreas({ title, subtitle, focusCity }: ServiceAreasProps) {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Content */}
          <div>
            <p className="text-xs font-body text-brand-amber uppercase tracking-widest font-semibold mb-3">
              Service Coverage
            </p>
            <h2 className="font-heading font-bold text-4xl lg:text-5xl text-brand-dark leading-tight mb-5">
              {title
                ? title.split("\n").map((line, i) => (
                    <span key={i}>
                      {line}
                      {i < title.split("\n").length - 1 && <br />}
                    </span>
                  ))
                : (
                  <>Serving Local<br />Communities</>
                )}
            </h2>
            <p className="font-body text-brand-charcoal leading-relaxed mb-8">
              {subtitle ??
                "Westec Builders proudly serves homeowners and businesses across the Colorado Springs region and surrounding communities. Our local expertise means faster response times, stronger supplier relationships, and a deep understanding of Front Range building codes and climate considerations."}
            </p>

            {/* Area list with service keywords */}
            <div className="flex flex-col gap-2 mb-8">
              {areas.map((area) => (
                <div
                  key={area.city}
                  className={`flex items-center justify-between px-4 py-3 rounded-lg border text-sm ${
                    area.city === focusCity
                      ? "bg-brand-amber text-white border-brand-amber"
                      : "border-brand-warm-deep text-brand-charcoal bg-brand-warm hover:border-brand-amber/40 transition-colors"
                  }`}
                >
                  <span className="font-body font-semibold">{area.city}</span>
                  <span className={`font-body text-xs ${area.city === focusCity ? "text-white/80" : "text-brand-charcoal/60"}`}>
                    {area.services}
                  </span>
                </div>
              ))}
            </div>

            <Link
              to="/location"
              className="inline-flex items-center gap-2 bg-brand-dark text-white px-6 py-3.5 rounded-full text-sm font-body font-semibold hover:bg-brand-charcoal transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-2-line" />
              </span>
              Check Your Area
            </Link>
          </div>

          {/* Map */}
          <div className="w-full h-[560px] rounded-2xl overflow-hidden border border-brand-warm-deep">
            <iframe
              title="Westec Builders Service Area — Colorado Springs, Colorado"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d197587.29785624766!2d-104.98282!3d38.8338816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8714a53e3e098bcf%3A0x5be7f4b5e5b6b6b6!2sColorado%20Springs%2C%20CO!5e0!3m2!1sen!2sus!4v1700000000000"
              className="w-full h-full border-0"
              loading="lazy"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
